// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getCart } from "@insite/client-framework/Services/CartService";
import {
    chain,
    GetCart,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { nullPage } from "@insite/client-framework/Store/Data/Pages/PagesState";

// this function is called on update and delete so adding additional expands once rather than changing 3 other files
export const XngExpandApiParameter: any = (props: any) => {
    const pageType = getCurrentPage(props.getState()).type;
    const { pathname } = getLocation(props.getState());

    props.apiParameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
        expand: ["validation"],
    };
    delete props.apiParameter.forceRecalculation;
    delete props.apiParameter.allowInvalidAddress;
    const timestamp = `time${new Date().getTime()}`;

    let xngExpand = ["cartLines", "restrictions", "properties"];
    if (
        props.parameter.fullExpand ||
        pageType === "CheckoutReviewAndSubmitPage" ||
        pageType === "CheckoutShippingPage" ||
        pageType === "OrderConfirmationPage" ||
        pageType === "CartPage"
    ) {
        let tempExpand = ["tax"];
        // https://xngage.atlassian.net/browse/BG-2304
        if (pageType === "CartPage" && !props.parameter.showTaxAndShipping) {
            tempExpand = [];
        }
        if (pageType === "CheckoutReviewAndSubmitPage" || pageType === "CheckoutShippingPage") {
            tempExpand.push("carriers");
            tempExpand.push("paymentOptions");
            props.apiParameter.forceRecalculation = true;
            props.apiParameter.allowInvalidAddress = true;
        }
        tempExpand.push("shipping");
        xngExpand = [...xngExpand, ...tempExpand];
    }

    // https://xngage.atlassian.net/browse/BG-2107
    // Fix price cashing issue on the Cart Page when switching between Delivery and Pickup
    if (pageType === "CartPage") {
        props.apiParameter.forceRecalculation = true;
    }

    if (pageType === "RfqRequestQuotePage" || (pageType === nullPage.type && pathname === "/Rfq")) {
        (props.apiParameter as any).IsRequestQuotePage = true;
    }

    xngExpand = [...xngExpand, timestamp];

    props.apiParameter.expand = [...(props.apiParameter.expand || []), ...xngExpand];
};

// using the custom get to add no-cache when updating the cart
export const XngGetCart: any = async (props: any) => {
    props.apiResult = await getCart(props.apiParameter);
};

replaceInChain(chain, GetCart, XngGetCart);
replaceInChain(chain, PopulateApiParameter, XngExpandApiParameter);
